import { createFeatureSelector, createSelector } from '@ngrx/store'
import { IStorageState } from '@adex/shared/models/states/storage.state'


const selectStorage = createFeatureSelector<IStorageState>('storageState')
export const selectFromStorage = <T extends keyof IStorageState>(key: T) => createSelector(selectStorage, state => state[key])
